import { combineReducers } from 'redux';
import user from './user/reducers';
import home from './home/reducers';
import modal from './modal/reducers';
import indicacao from './indicacao/reducers';
import categorias from './categorias/reducers';
import produtos from './produtos/reducers';
import errors from './errors/reducers';
import perguntas from './perguntas/reducers';
import loading from './loading/reducers';
import help from './help/reducers';
import newNotifications from './newNotifications/reducers';
import svas from './svaList/reducers';
import cardPassword from './cardPassword/reducers';
import recaptcha from './recaptcha/reducers';
import issuer from './issuer/reducers';
import refreshToken from './refreshToken/reducers';
import { Types as userTypes } from './user/actions';

const appReducer = combineReducers({
  user,
  home,
  modal,
  indicacao,
  categorias,
  produtos,
  errors,
  perguntas,
  loading,
  help,
  newNotifications,
  svas,
  cardPassword,
  recaptcha,
  issuer,
  refreshToken,
});

const rootReducer = (state, action) => {
  if (action?.type === userTypes?.LOGOUT) {
    return appReducer(
      {
        issuer: state?.issuer,
      },
      action,
    );
  }

  return appReducer(state, action);
};

export default rootReducer;
